export default "__VITE_ASSET__BXgjksFy__"